<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>

                </v-card-title>
                <div>
                    <v-tabs  v-model="tabs" color="#1C3071" grow>
                        <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                            Envoyé
                        </v-tab>
                        <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                            Brouillon
                        </v-tab>
                        <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                            Corbeille
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tabs">
                        <!--NOTIFICATION -->
                        <v-tab-item>
                            <v-card flat>
                                <Envoyer></Envoyer>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <Brouillon ></Brouillon>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <Corbeille ></Corbeille>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </v-card>

        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "../../../../mixins/helpers";
    import Envoyer from "./Envoyer";
    import Brouillon from "./Brouillon";
    import Corbeille from "./Corbeille";

    export default {
        name: "ListNewsletter",
        components: {Corbeille, Brouillon, Envoyer},
        mixins:[helpers(this)],
        data () {
            return {
                submitting:false,
                valid:true,
                lazy:false,
                mis:false,
                tabs: null,
                search_key:'',
                errors:{},
                userdetails:{},
                customSnack:{
                    snackbar: false,
                    text: "",
                    snackcolor:"black",
                    snackbBtnColor:"white",
                    snacktimeout:2000
                },
                search: '',
                desc:"",
                dialog1: false,
                dialog2: false,
                dialog: '',
                id:undefined,
                editedIndex: -1,
                editedItem: {
                    _description: '',
                    _code: '',
                    _id:''
                },
                defaultItem: {
                    _description: '',
                    _code: '',
                    _created_at: 0,
                    _id:''
                },
                labelRules: [
                    v => !!v || this.$t('name_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codeRules: [
                    v => !!v || this.$t('code_required'),
                ],
                descriptionRules: [
                    v => !!v || this.$t('description_required'),
                ],
                fileRules: [
                    v => !!v || this.$t('file_required'),
                ],
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? this.$t('categoriemarchand.new_categorie') : this.$t('categoriemarchand.update_categorie')
            },
            ...mapState('newsletters/',['newsletters']),
            drop_down_categorie: function(){

                return [{text:"Tous les mails",value:-1},{text:"Envoyer",value:"envoyer"},{text:"Brouillons",value:"brouillon"},{text:"Dans Corbeille",value:'corbeille'}];
            },
        },
        mounted(){
            this.$store.dispatch('newsletters/get').then(response=>{
                console.log('newsletters',response)
            });
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
            dialog1 (val) {
                val || this.close1()
            },
            dialog2 (val) {
                val || this.close1()
            },
        },
        methods: {
            initialize () {
                this.langues = [
                    {
                        name:'Bénin',
                        code_iso_alpha_2:'BJ',
                        code_iso_alpha_3:'BEN',
                        code_iso_numerique:204
                    }
                ]
            },
            showdescription(vdes){
                if (vdes===undefined) {
                    this.desc = 'Vide';
                    this.dialog1 = true;
                }else{
                    this.desc = vdes;
                    this.dialog1 = true;
                }

            },
            userdetail(vdes){
                if (vdes===undefined) {
                    this.userdetails= 'Vide';
                    this.dialog2 = true;
                }else{
                    this.userdetails = vdes;
                    this.dialog2 = true;
                }

            },
            filterMarchands(criteria){

                if (criteria==="role")
                    this.$store.dispatch('users/filterUsersByRole', this.role_key).then(() => {});
                else
                    this.$store.dispatch('newsletters/filter', this.search_key).then(() => {});
            },
            editItem (item) {
                this.editedIndex = this.newsletters.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true;
                this.id = item._id;
            },
            deleteItem (item) {
                let VueBox=this;
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    confirmButtonColor:'#29B3A6',
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.submitting = true;
                        this.$store.dispatch('newsletters/delete', item._id).then((result) => {
                            this.submitting = false ;
                            if (!result.error){
                                VueBox.toast('success',this.$t(result.message));

                            }
                        })
                    }
                })
            },
            corbeille (item) {
                let VueBox=this;

                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: 'Vous êtes sûr de vouloir deplacer cet élément dans la corbeille ?',
                    confirmButtonText: "Oui",
                    cancelButtonText: "Non",
                    confirmButtonColor:'#29B3A6',
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.submitting = true;
                        this.$store.dispatch('newsletters/corbeille', item._id).then((result) => {
                            this.submitting = false ;
                            if (!result.error){
                                VueBox.toast('success',this.$t(result.message));

                            }
                        })
                    }
                })
            },
            restitue (item) {
                let VueBox=this;

                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: 'Vous êtes sûr de vouloir deplacer cet élément dans la liste des envoies ?',
                    confirmButtonText: "Oui",
                    cancelButtonText: "Non",
                    confirmButtonColor:'#29B3A6',
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.submitting = true;
                        this.$store.dispatch('newsletters/restitue', item._id).then((result) => {
                            this.submitting = false ;
                            if (!result.error){
                                VueBox.toast('success',this.$t(result.message));

                            }
                        })
                    }
                })
            },
            description (item) {
                Swal.fire({
                    title: this.$t('description'),
                    timerProgressBar: false,
                    text: item._description,
                    confirmButtonText: "OK",
                    confirmButtonColor:'#29B3A6',
                })
            },

            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            close1 () {
                this.dialog1 = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
            },
            close2 () {
                this.dialog2 = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
            },

            save () {
                this.customSnack.snackbar = false;
                this.mis=true;
                let VueBox = this;
                let data = new FormData();
                data.append("code",this.editedItem._code);
                data.append("description",this.editedItem._description);
                data.append("name",this.editedItem._name);
                if (this.id)
                    data.append("id",this.id);
                this.submitting = true;
                this.$store.dispatch('category_marchands/setCategorie_Marchand',data).then((response)=>{
                    console.log('set categorie response',response)
                    this.submitting = false;
                    if (response.error){
                        this.errors.operation=response.message;
                    }else{
                        VueBox.$parent.resetDatas(VueBox);
                        this.close();
                        if (!response.error){
                            VueBox.toast('success',this.$t(response.message));

                        }
                    }
                })
            },
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },
    }
</script>

<style scoped>

</style>